/* eslint-disable react-hooks/exhaustive-deps */
/*eslint-disable @typescript-eslint/restrict-plus-operands */
import {
    Dispatch,
    FC,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from "react";
import clsx from "clsx";
import { ScrollBar, Button } from "@ht/components";

import VideoOffIcon from "@ht/shared/fonts/deos-pis/video-camera-off";
import VideoOnIcon from "@ht/shared/fonts/deos-pis/video-camera";
import MuteIcon from "@ht/shared/fonts/deos-pis/mic-mute";
import UnmuteIcon from "@ht/shared/fonts/deos-pis/mic";
import NotTalkIcon from "@ht/shared/fonts/deos-pis/radio-none";
import ShareScreenIcon from "@ht/shared/fonts/deos-pis/monitor";
import HangupIcon from "@ht/shared/fonts/deos-pis/call-hangup";
import ChatIcon from "@ht/shared/fonts/deos-pis/chat";
import FullScreenIcon from "@ht/shared/fonts/deos-pis/fullscreen";
import ExitFullScreenIcon from "@ht/shared/fonts/deos-pis/exit-fullscreen";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
    vCallIncomingMessageReceived,
    vCallSendMessage,
    vCallStateChanged,
} from "../../../../app/videocall/videoSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";

import { useDragging } from "../../../../hooks/useDragging";
import VideoCard from "../Cards/VideoCard";
import { useNavigate, useParams } from "react-router-dom";
import { AntmediaContext } from "../../../../App";
import { SettingsContext, MediaSettingsContext } from "../../DMSMedia";
import ProfileBody from "../../../../pages/chat/components/ProfileBody";
import {
    ICustomerData,
    IIncomingRoom,
    IMessage,
} from "../../../../app/chat/types";
import MessageHeader from "../../../../pages/chat/components/MessageHeader";
import MessageBody from "../../../chat/MessageBody";
import MessageFooter from "../../../../pages/chat/components/MessageFooter";
import dayjs from "dayjs";
import { readMessage, activeChatRoom } from "../../../../app/chat/chatSlice";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
import moment from "moment";
import RightPanel from "../../../../pages/chat/components/RightPanel";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import {
    IVCallIncomingMessage,
    IVCallState,
} from "../../../../app/videocall/types";
import { decodeRouteParam, encodeRouteParam } from "../../../../utils/routeParam";

type LocalData = {
    streamId: string;
};
interface IProps {
    participants: any[];
    allParticipants: any[];
    myLocalData: LocalData | undefined;
    roomName: string;
}
const LoadPinnedParticipant = (
    pinVideoId: string,
    fullscreen: boolean,
    participants: any[],
    setPinRemoteVideo: Dispatch<SetStateAction<boolean>>,
    pinRemoteVideo: boolean,
    setPinVideoId: Dispatch<SetStateAction<string>>,
    msettings: any
) => {
    return participants
        .filter((p) => pinVideoId === p.id)
        .map(({ id, track }, index) => {
            const key = `pin${index}`;
            return (
                <div
                    key="PINNEDREMOTEVIDEO"
                    className={clsx(
                        { "w-[520px] h-[100%] rounded-lg": !fullscreen },
                        { "w-[75vw] h-[calc(100vh_-_54px)]": fullscreen }
                    )}
                >
                    <div
                        className={clsx(
                            "shadow-sm rounded-lg h-[100%] bg-black"
                        )}
                        key={key}
                    >
                        <VideoCard
                            onHandlePin={() => {
                                console.log("pinning not local video");
                                setPinRemoteVideo(true);
                                setPinVideoId(id);
                            }}
                            id={id}
                            track={track}
                            autoPlay
                            name={msettings.customerName}
                            pinned={true}
                        />
                    </div>
                </div>
            );
        });
};
const LoadLocalVideo = (
    pinVideoId: string,
    fullscreen: boolean,
    participants: any[],
    setPinRemoteVideo: Dispatch<SetStateAction<boolean>>,
    pinRemoteVideo: boolean,
    setPinVideoId: Dispatch<SetStateAction<string>>
) => {
    return (
        <div
            key="localvideo"
            className={clsx(
                {
                    "absolute m-[8px] overflow-hidden shadow-sm rounded-lg z-[21]":
                        pinVideoId !== "localVideo",
                },
                {
                    "w-[120px] top-[0px] right-[0px]":
                        pinVideoId !== "localVideo" && !fullscreen,
                },
                {
                    "w-[240px] top-[0px] left-[calc(75vw_-_256px)]":
                        pinVideoId !== "localVideo" && fullscreen,
                },
                {
                    "w-[520px] h-[100%]":
                        pinVideoId === "" ||
                        (pinVideoId === "localVideo" && !fullscreen),
                },
                {
                    "w-[75vw] h-[calc(100vh_-_54px)]":
                        pinVideoId === "" ||
                        (pinVideoId === "localVideo" && fullscreen),
                }
            )}
        >
            <div
                className={clsx(
                    pinRemoteVideo && "rounded-lg shadow-sm",
                    "bg-black h-[100%]"
                )}
            >
                <VideoCard
                    onHandlePin={() => {
                        console.log("pinning local video");
                        setPinRemoteVideo(false);
                        setPinVideoId("localVideo");
                    }}
                    id="localVideo"
                    autoPlay
                    name="You"
                    muted
                    hidePin={participants.length === 0}
                    pinned={pinVideoId === "localVideo" || pinVideoId === ""}
                />
            </div>
        </div>
    );
};
const LoadUnpinnedParticipants = (
    pinVideoId: string,
    fullscreen: boolean,
    participants: any[],
    setPinRemoteVideo: Dispatch<SetStateAction<boolean>>,
    setPinVideoId: Dispatch<SetStateAction<string>>,
    msettings: any
) => {
    return (
        <div
            key="UNPINNEDREMOTEVIDEO"
            className={clsx(
                " flex flex-col gap-[10px] absolute m-[8px] z-[21]",
                { "w-[120px] right-[0px]": !fullscreen },
                { "w-[240px] left-[calc(75vw_-_256px)]": fullscreen },
                {
                    "top-[0px] ":
                        pinVideoId === "localVideo" || pinVideoId === "",
                },
                {
                    "top-[200px]":
                        fullscreen &&
                        pinVideoId !== "localVideo" &&
                        pinVideoId !== "",
                },
                {
                    "top-[100px]":
                        !fullscreen &&
                        pinVideoId !== "localVideo" &&
                        pinVideoId !== "",
                }
            )}
        >
            {participants
                .filter((p) => pinVideoId !== p.id)
                .map(({ id, track }, index) => {
                    const k = `key${index}`;
                    return (
                        <div
                            className={clsx(
                                { "w-[240px]": fullscreen },
                                { "w-[120px]": !fullscreen },
                                "shadow-sm rounded-lg h-[100%] bg-black"
                            )}
                            key={k}
                        >
                            <VideoCard
                                onHandlePin={() => {
                                    console.log("pinning not local video");
                                    setPinRemoteVideo(true);
                                    setPinVideoId(id);
                                }}
                                id={id}
                                track={track}
                                autoPlay
                                name={msettings.customerName}
                                pinned={pinVideoId === id}
                            />
                        </div>
                    );
                })}
        </div>
    );
};
const VideoCallControl: FC<IProps> = ({
    participants,
    allParticipants,
    myLocalData,
    roomName,
}) => {
    const dispatch = useAppDispatch();

    const antmedia = useContext(AntmediaContext);
    const msettings = useContext(MediaSettingsContext);

    const settings = useContext(SettingsContext);
    const { pinnedVideoId, audioTracks } = settings;

    const [pinRemoteVideo, setPinRemoteVideo] = useState(true);
    const [pinVideoId, setPinVideoId] = useState("");
    const [roomId, setRoomId] = useState("");

    useEffect(() => {
        const localVid = document.getElementById("localVideo");
        console.log("mediamanager", antmedia.mediaManager);
        if (localVid && antmedia.mediaManager) {
            antmedia.mediaManager.localVideo =
                document.getElementById("localVideo");
            if (antmedia.mediaManager.localVideo)
                (
                    antmedia.mediaManager.localVideo as HTMLVideoElement
                ).srcObject = antmedia.mediaManager.localStream;
        }
    }, [pinnedVideoId]);

    useEffect(() => {
        if (!pinVideoId) setPinVideoId("localVideo");
    }, [participants, pinnedVideoId]);

    //-------------------------------

    const { user } = useAppSelector((state) => state.auth);
    const { vCallIncomingMessage, vCallState } = useAppSelector(
        (state) => state.vcall
    );

    const { incomingRoom, activeRoom, messages, scrollPosition } =
        useAppSelector((state) => state.chat);
    const { floatingLocation, overlay } = useAppSelector(
        (state) => state.layoutstate
    );

    const [duration, setDuration] = useState(
        vCallState.duration > 0 ? vCallState.duration : 0
    );
    const [intervalId, setIntervalId] = useState(0);
    const [joinedRoom] = useState(false);
    const callnotifWidth = 520;
    const locationX =
        floatingLocation.x === 0
            ? (screen.width - callnotifWidth) / 2
            : floatingLocation.x;
    const locationY =
        floatingLocation.y === 0 ? floatingLocation.y + 66 : floatingLocation.y;
    const [fullscreen, setFullscreen] = useState(false);
    const { ref, x, y, isDragging } = useDragging(
        locationX,
        locationY,
        520,
        420
    );

    const { chatId } = useParams();
    const [rightPanel, setRightPanel] = useState("profile");

    const navigate = useNavigate();
    const [opponent, setOpponent] = useState<IIncomingRoom>();
    const [chatList, setChatList] = useState<IMessage[]>();
    const [isScroll, setIsScroll] = useState(false);
    const [username, setUsername] = useState(vCallIncomingMessage.username);
    const { sendRequest } = useHttpRequest();
    const customerBaseUrl = String(process.env.REACT_APP_CUSTOMER_SERVICE);
    const [customerData, setCustomerData] = useState<ICustomerData>({
        id: undefined,
        profile_picture: "",
        fullname: undefined,
        email: [""],
        dob: moment().unix(),
        gender: "male",
        phone_number: [""],
        facebook_ids: [""],
        religion: "",
        address: "",
        tenant_id: user?.tenantId,
        room_id: activeRoom?.roomId,
    });
    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
        dispatch(vCallStateChanged({} as IVCallState));
    };
    const requestStream = () => {
        if (!user) return;
        setUsername(vCallIncomingMessage.username);
        const payload = {
            content: JSON.stringify({
                callid: vCallState.CallId,
                sessionid: vCallIncomingMessage.sessionid,
                requesttype: "RequestStream",
                deviceid: vCallIncomingMessage.deviceid,
                username: vCallIncomingMessage.username,
                subscriptionid: process.env.REACT_APP_SUBSCRIPTIONID,
                destdeviceid: "agentStream" + user.deviceId,
                destusername: user.username,
                type: "agent",
                tag: "generic",
                channel: vCallIncomingMessage.channel,
                calltype: vCallIncomingMessage.calltype,
            }),
        };

        dispatch(vCallSendMessage(payload));
    };

    useEffect(() => {
        if (messages && opponent) {
            const filteredMessages = messages.filter(
                (a) => a.roomId == opponent.roomId
            );
            const sortedMessages = filteredMessages.sort(
                (a, b) =>
                    new Date(
                        dayjs(a.messageTime).format("YYYY-MM-DD HH:mm:ss")
                    ).getTime() -
                    new Date(
                        dayjs(b.messageTime).format("YYYY-MM-DD HH:mm:ss")
                    ).getTime()
            );
            setChatList(sortedMessages);
        }
    }, [messages, opponent]);
    const changeRoom = () => {
        if (roomId) {
            const currentActiveRoom = incomingRoom.find(
                (z) => z.roomId === roomId
            );
            if (currentActiveRoom) {
                dispatch(activeChatRoom(currentActiveRoom));
            }

            if (scrollPosition == "bottom") setIsScroll((prev) => !prev);
            dispatch(
                readMessage({
                    sessionId: currentActiveRoom?.sessionId,
                    messageId: 0,
                })
            );
            setOpponent(incomingRoom.find((a) => a.roomId == roomId));
        }
    };
    useEffect(() => {
        if (incomingRoom.length > 0 && activeRoom !== undefined) {
            changeRoom();
        }
    }, [incomingRoom, activeRoom]);
    useEffect(() => {
        if (chatId) setRoomId(decodeRouteParam(chatId));
    }, [chatId]);
    useEffect(() => {
        if (scrollPosition == "bottom") setIsScroll((prev) => !prev);
    }, [scrollPosition, chatList]);
    let timer: number;
    const startTimer = () => {
        if (intervalId !== undefined) {
            timer = window.setInterval(() => {
                setDuration((dur) => dur + 1);
            }, 1000);
            setIntervalId(timer);
        }
    };
    const stopTimer = () => {
        window.clearInterval(intervalId);
    };
    const toHHMMSS = (dur: number) => {
        const hours = Math.floor(dur / 3600);
        const minutes = Math.floor((dur - hours * 3600) / 60);
        const seconds = dur - hours * 3600 - minutes * 60;
        let strhours = hours.toString();
        let strminutes = minutes.toString();
        let strseconds = seconds.toString();

        if (hours < 10) {
            strhours = "0" + hours.toString();
        }
        if (minutes < 10) {
            strminutes = "0" + minutes.toString();
        }
        if (seconds < 10) {
            strseconds = "0" + seconds.toString();
        }
        return strhours + ":" + strminutes + ":" + strseconds;
    };

    useEffect(() => {
        console.log("chatid changed opponent", activeRoom, incomingRoom);
        setOpponent(incomingRoom.find((a) => a.roomId === activeRoom.roomId));
    }, [activeRoom, incomingRoom]);

    const mic = msettings?.mic?.find(
        (m: { eventStreamId: string }) => m.eventStreamId === "localVideo"
    );
    const cam = msettings?.cam?.find(
        (m: { eventStreamId: string }) => m.eventStreamId === "localVideo"
    );

    const toggleStyle = (
        toggle: boolean,
        styleTrue: string,
        styleFalse: string
    ):
        | "warning"
        | "success"
        | "light"
        | "primary"
        | "secondary"
        | "danger"
        | "info"
        | "purple"
        | "facebook"
        | "twitter"
        | "royal"
        | undefined => {
        return (toggle ? styleTrue : styleFalse) as
            | "warning"
            | "success"
            | "light"
            | "primary"
            | "secondary"
            | "danger"
            | "info"
            | "purple"
            | "facebook"
            | "twitter"
            | "royal"
            | undefined;
    };
    const cameraOff = () => {
        if (!msettings.isScreenShared) {
            msettings?.toggleSetCam({
                eventStreamId: "localVideo",
                isCameraOn: false,
            });
            if (myLocalData?.streamId) {
                antmedia.turnOffLocalCamera(myLocalData.streamId);
                antmedia.handleSendNotificationEvent(
                    "CAM_TURNED_OFF",
                    myLocalData.streamId
                );
            } else {
                antmedia.turnOffLocalCamera("localVideo");
            }
        }
    };
    const cameraOn = () => {
        msettings?.toggleSetCam({
            eventStreamId: "localVideo",
            isCameraOn: true,
        });

        if (myLocalData?.streamId) {
            antmedia.turnOnLocalCamera(myLocalData.streamId);
            antmedia.handleSendNotificationEvent(
                "CAM_TURNED_ON",
                myLocalData.streamId
            );
        } else {
            antmedia.turnOnLocalCamera("localVideo");
        }
    };
    const muteMic = () => {
        msettings?.toggleSetMic({
            eventStreamId: "localVideo",
            isMicMuted: true,
        });
        antmedia.muteLocalMic();
        if (msettings?.myLocalData?.streamId) {
            antmedia.handleSendNotificationEvent(
                "MIC_MUTED",
                msettings?.myLocalData?.streamId
            );
            antmedia.updateAudioLevel(msettings?.myLocalData?.streamId, 0);
        }
    };
    const unmuteMic = () => {
        msettings?.toggleSetMic({
            eventStreamId: "localVideo",
            isMicMuted: false,
        });
        antmedia.unmuteLocalMic();
        if (msettings?.myLocalData?.streamId) {
            antmedia.handleSendNotificationEvent(
                "MIC_UNMUTED",
                msettings?.myLocalData?.streamId
            );
        }
    };

    const toggleShare = () => {
        if (msettings?.isScreenShared) {
            antmedia.handleStopScreenShare();
        } else {
            antmedia.handleStartScreenShare();
            // send other that you are sharing screen.
        }
    };
    const toggleMute = () => {
        if (mic?.isMicMuted) unmuteMic();
        else muteMic();
    };
    const toggleCamera = () => {
        if (cam?.isCameraOn) cameraOff();
        else cameraOn();
    };
    const toggleFullscreen = () => {
        const cfullscreen = !fullscreen;
        setFullscreen(cfullscreen);
        if (cfullscreen) navigate(`/messages/${encodeRouteParam(username)}`);
    };
    const hangupVideoCall = () => {
        stopTimer();
        cameraOff();

        dispatch(setOnCall(""));
        if (antmedia.publishStreamId) {
            antmedia.handleLeaveFromRoom();
        }
        msettings?.setLeftTheRoom(true);
        resetIncomingCall();
    };

    useEffect(() => {
        if (
            vCallIncomingMessage.roomId != undefined &&
            vCallIncomingMessage.streamId !== null &&
            !joinedRoom
        ) {
            antmedia.joinRoom(roomName, vCallIncomingMessage.streamId, "mcu");

            startTimer();
        } else if (
            vCallIncomingMessage.requesttype
                ?.toLowerCase()
                .includes("LeaveRoom") &&
            joinedRoom
        ) {
            hangupVideoCall();
        }
    }, [vCallIncomingMessage]);

    const retrieveDataCustomer = async () => {
        const dt = await sendRequest({
            baseUrl: customerBaseUrl,
            url: `customer-room/${activeRoom?.roomId}`,
            method: "get",
        });
        if (dt.data) {
            setCustomerData(dt.data as any);
        }
    };
    useEffect(() => {
        requestStream();
        cameraOff();
        setTimeout(() => {
            retrieveDataCustomer().catch((err) => {
                console.log(err);
            });
        }, 1000);
    }, []);
    return (
        <>
            <div
                onClick={() => dispatch(setOverlay(false))}
                onKeyDown={() => {}}
                role="none"
                className={clsx(
                    "fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                    { hidden: !overlay }
                )}
            ></div>
            <div
                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    { "bg-geyser": isDragging },
                    { "bg-white": !isDragging },
                    { "w-[520px] h-[260px] rounded-lg": !fullscreen },
                    { "w-[100%]": fullscreen },
                    { "!top-[54px] !left-0": fullscreen },
                    `absolute shadow-sm bg-white z-[21] overflow-hidden min-h-[260px]`
                )}
            >
                <div className="flex flex-col justify-between items-center h-[100%]">
                    <div className="absolute top-0 bg-white rounded-lg m-[8px] p-[8px] text-md self-start z-[99] flex flex-row">
                        <div className="hover:bg-geyser rounded-lg ">
                            <NotTalkIcon className="text-gray-200 w-[16px] h-[16px]" />
                        </div>
                        <div className="rounded-lg ml-[8px]">
                            <div className="flex flex-row gap-[8px] items-center leading-4">
                                <span className="font-semibold text-black text-md">
                                    {msettings.customerName}
                                </span>
                                <span className="text-base text-grey-200 border-l-grey-200 border-l-[1px] pl-[8px]">
                                    {toHHMMSS(duration)}
                                </span>
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="flex flex-row h-[100%]">
                            {audioTracks.map((audio: any, index: number) => {
                                const key = `key${index}`;
                                return (
                                    <VideoCard
                                        key={key}
                                        onHandlePin={() => {}}
                                        id={audio.streamId}
                                        track={audio.track}
                                        autoPlay
                                        name={""}
                                        style={{ display: "none" }}
                                    />
                                );
                            })}
                            <div
                                ref={ref}
                                id="meeting-gallery" /*style={{ height: "calc(100vh - 80px)" }}*/
                            >
                                {
                                    <>
                                        {LoadPinnedParticipant(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            pinRemoteVideo,
                                            setPinVideoId,
                                            msettings
                                        )}
                                        {LoadUnpinnedParticipants(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            setPinVideoId,
                                            msettings
                                        )}
                                        {LoadLocalVideo(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            pinRemoteVideo,
                                            setPinVideoId
                                        )}
                                        <div
                                            className={clsx(
                                                "draggable absolute p-[16px] bottom-[0px] flex flex-col items-center",
                                                { "w-[100%]": !fullscreen },
                                                { "w-[75vw]": fullscreen }
                                            )}
                                        >
                                            <div
                                                className={clsx(
                                                    "rounded-md bg-white h-[52px] py-[8px] px-[16px] gap-[20px] flex flex-row justify-between "
                                                )}
                                            >
                                                <div className="flex flex-row-reverse justify-end gap-[12px] items-center">
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={
                                                            hangupVideoCall
                                                        }
                                                        type="button"
                                                        variant="contained"
                                                        color="danger"
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        <HangupIcon className="w-[20px] h-[20px] text-white" />
                                                    </Button>
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={toggleMute}
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            mic?.isMicMuted,
                                                            "primary",
                                                            "light"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        {mic?.isMicMuted ? (
                                                            <MuteIcon
                                                                className={clsx(
                                                                    "w-[20px] h-[20px] text-grey-200"
                                                                )}
                                                            />
                                                        ) : (
                                                            <UnmuteIcon
                                                                className={clsx(
                                                                    "w-[20px] h-[20px] text-grey-200"
                                                                )}
                                                            />
                                                        )}
                                                    </Button>
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={toggleCamera}
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            cam?.isCameraOn,
                                                            "light",
                                                            "primary"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        {cam?.isCameraOn ? (
                                                            <VideoOnIcon className="w-[20px] h-[20px] text-grey-200" />
                                                        ) : (
                                                            <VideoOffIcon className="w-[20px] h-[20px] text-grey-200" />
                                                        )}
                                                    </Button>
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={toggleShare}
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            msettings?.isScreenShared,
                                                            "primary",
                                                            "light"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        <ShareScreenIcon
                                                            className={clsx(
                                                                "w-[20px] h-[20px] text-grey-200"
                                                            )}
                                                        />
                                                    </Button>

                                                    {fullscreen && (
                                                        <>
                                                            <Button
                                                                shape="ellipse"
                                                                onClick={() =>
                                                                    rightPanel ===
                                                                    "chat"
                                                                        ? setRightPanel(
                                                                              "profile"
                                                                          )
                                                                        : setRightPanel(
                                                                              "chat"
                                                                          )
                                                                }
                                                                type="button"
                                                                variant="contained"
                                                                color={toggleStyle(
                                                                    rightPanel ===
                                                                        "chat",
                                                                    "primary",
                                                                    "light"
                                                                )}
                                                                iconButton
                                                                className="w-[32px] h-[32px]"
                                                            >
                                                                <ChatIcon
                                                                    className={clsx(
                                                                        "w-[20px] h-[20px] text-grey-200"
                                                                    )}
                                                                />
                                                            </Button>
                                                        </>
                                                    )}
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={
                                                            toggleFullscreen
                                                        }
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            msettings?.isScreenShared,
                                                            "primary",
                                                            "light"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        {fullscreen && (
                                                            <ExitFullScreenIcon
                                                                className="w-[20px] h-[20px] text-grey-200"
                                                                width={24}
                                                                height={24}
                                                            />
                                                        )}
                                                        {!fullscreen && (
                                                            <FullScreenIcon
                                                                className="w-[20px] h-[20px] text-grey-200"
                                                                width={24}
                                                                height={24}
                                                            />
                                                        )}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            {fullscreen && (
                                <div className="w-[25vw]">
                                    {opponent && rightPanel === "profile" && (
                                        <RightPanel
                                            title="Customer Contact"
                                            visible={true}
                                            hideOptions={true}
                                        >
                                            <ProfileBody
                                                opponent={opponent}
                                                customerData={customerData}
                                                onUpdatedCustomer={() => {
                                                    retrieveDataCustomer().catch(
                                                        (err) => {
                                                            console.log(err);
                                                        }
                                                    );
                                                }}
                                            />
                                        </RightPanel>
                                    )}
                                    {opponent && rightPanel === "chat" && (
                                        <div className={clsx("h-[100%]")}>
                                            <div className={clsx("h-[100%]")}>
                                                <MessageHeader
                                                    customerData={customerData}
                                                    name={
                                                        customerData.fullname ??
                                                        opponent.fullName
                                                    }
                                                    status={opponent.status}
                                                    hideOptions={true}
                                                />
                                                <ScrollBar
                                                    className="bg-gray-50"
                                                    initialView="bottom"
                                                    bottom="120px"
                                                    onScrollUp={() => {}}
                                                    isPositionChange={isScroll}
                                                >
                                                    <MessageBody
                                                        chats={chatList}
                                                    />
                                                </ScrollBar>
                                                <MessageFooter
                                                    roomId={opponent.roomId}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                </div>
            </div>
        </>
    );
};

export default VideoCallControl;
